import { render, staticRenderFns } from "./Newsletters.vue?vue&type=template&id=49b0584f&"
import script from "./Newsletters.vue?vue&type=script&lang=js&"
export * from "./Newsletters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports